import React, { useMemo, useState } from "react";

const Contact = () => {
  const emailTo = "lisa.latifi@lissacodes.com";

  const [form, setForm] = useState({
    name: "",
    email: "",
    service: "Website build",
    budget: "1000-3000",
    message: "",
  });

  const [error, setError] = useState("");

  const subject = useMemo(() => `Website inquiry: ${form.service}`, [form.service]);

  const mailtoHref = useMemo(() => {
    const lines = [
      `Hi Lisa,`,
      ``,
      `My name is: ${form.name || "(not provided)"}`,
      `My email: ${form.email || "(not provided)"}`,
      `Interested in: ${form.service}`,
      `Budget range: ${form.budget}`,
      ``,
      `Message:`,
      `${form.message || "(no message yet)"}`,
      ``,
      `Thanks!`,
    ];

    return `mailto:${emailTo}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(lines.join("\n"))}`;
  }, [emailTo, form, subject]);

  const validate = () => {
    if (!form.name.trim()) return "Please enter your name.";
    if (!form.email.trim()) return "Please enter your email.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) return "Please enter a valid email address.";
    if (!form.message.trim()) return "Please tell me a bit about your project.";
    return "";
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const nextError = validate();
    setError(nextError);
    if (nextError) return;
    window.location.href = mailtoHref;
  };

  const fieldClass =
    "w-full border-0 border-b border-white/20 bg-transparent py-3 text-white placeholder:text-white/35 focus:border-white focus:outline-none";

  return (
    <section id="contact" className="scroll-mt-24 bg-ink py-20 text-white lg:py-24" style={{ colorScheme: "dark" }}>
      <div className="site-wrap grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="text-[11px] uppercase tracking-label text-white/45">Contact</p>
          <h2 className="mt-3 text-3xl font-light tracking-tight sm:text-5xl">
            Let’s build your next website or system.
          </h2>
          <p className="mt-5 max-w-md leading-relaxed text-white/55">
            Tell me about the project and I’ll help you with the next steps.
          </p>

          <div className="mt-10 space-y-4 text-sm">
            <a
              href={`mailto:${emailTo}`}
              className="block text-white transition hover:opacity-60"
            >
              lisa.latifi@lissacodes.com
            </a>
            <a
              href="https://instagram.com/lissacodes"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white/70 transition hover:text-white"
            >
              Instagram · lissacodes
            </a>
            <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/40">
              Remote-friendly
            </p>
          </div>
        </div>

        <form
          id="contact-form"
          onSubmit={onSubmit}
          className="space-y-8 lg:col-span-6 lg:col-start-7"
        >
          {error ? (
            <p className="border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </p>
          ) : null}

          <div className="grid gap-8 sm:grid-cols-2">
            <div>
              <label htmlFor="name" className="text-[11px] uppercase tracking-label text-white/45">
                Name
              </label>
              <input
                id="name"
                type="text"
                value={form.name}
                onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                placeholder="Your name"
                className={fieldClass}
              />
            </div>
            <div>
              <label htmlFor="email" className="text-[11px] uppercase tracking-label text-white/45">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={form.email}
                onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                placeholder="you@email.com"
                className={fieldClass}
              />
            </div>
          </div>

          <div className="grid gap-8 sm:grid-cols-2">
            <div>
              <label htmlFor="service" className="text-[11px] uppercase tracking-label text-white/45">
                Service
              </label>
              <select
                id="service"
                value={form.service}
                onChange={(e) => setForm((f) => ({ ...f, service: e.target.value }))}
                className={fieldClass}
              >
                <option>Website build</option>
                <option>Internal system</option>
                <option>Fullstack product</option>
                <option>Landing page</option>
                <option>E-commerce</option>
                <option>Website redesign</option>
                <option>Other</option>
              </select>
            </div>
            <div>
              <label htmlFor="budget" className="text-[11px] uppercase tracking-label text-white/45">
                Budget
              </label>
              <select
                id="budget"
                value={form.budget}
                onChange={(e) => setForm((f) => ({ ...f, budget: e.target.value }))}
                className={fieldClass}
              >
                <option value="500-1000">500–1000</option>
                <option value="1000-3000">1000–3000</option>
                <option value="3000-7000">3000–7000</option>
                <option value="7000+">7000+</option>
              </select>
            </div>
          </div>

          <div>
            <label htmlFor="message" className="text-[11px] uppercase tracking-label text-white/45">
              Project details
            </label>
            <textarea
              id="message"
              rows="5"
              value={form.message}
              onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
              placeholder="Goals, timeline, anything useful…"
              className={`${fieldClass} resize-none`}
            />
          </div>

          <button type="submit" className="btn-on-dark w-full sm:w-auto">
            Create email draft
          </button>
          <p className="text-xs leading-relaxed text-white/40">
            Your email app will open with the message prefilled. Nothing is stored on this site.
          </p>
        </form>
      </div>
    </section>
  );
};

export default Contact;
